import { GiveawayAnswer } from '@/fairplayer/domain/giveaway/GiveawayAnswer';

export interface GiveawayAnswerUi {
  id: string;
  text: string;
}

export const fromGiveawayAnswer = (giveawayAnswer: GiveawayAnswer): GiveawayAnswerUi => ({
  id: giveawayAnswer.id,
  text: giveawayAnswer.text,
});
